import React, { useState } from 'react';
import styles from './heremap.module.scss';
import NTMButton from '../../components/Buttons/NTMButton';
import { Formik, Form, Field, ErrorMessage } from "formik";

const Toolbar = ({devices, onSubmit, onRemove, data}) => {

    const [boundDevices, setBoundDevices] = useState(data && data.devices ? data.devices : []);

    let devicesIds = []
        devices.map(device => {
            const deviceId = device.deviceId;
            return devicesIds.push(deviceId)
        })

    const initialValues = {
        id: data && data.id,
        label: data && data.label,
        type: data && data.type,
    };

    const movementTypes = [
        {name:'Seleziona Movimento', value: null},
        {name:'In Entrata', value:"in"},
        {name:'In Uscita', value:"out"},
        {name:'In Entrata/Uscita', value:"inout"},
    ];

    const handleSubmit = (label, type) => {
        let areaInfo = {
            id: data && data.id,
            label: label,
            type: type,
            devices: boundDevices
        }
        onSubmit(areaInfo)
    }

    const cleanUpForm = () => {
        setBoundDevices([])
    }
    return (
        <div className={styles['toolbar-container']}>
            <Formik
                enableReinitialize
                validateOnBlur={false}
                initialValues={initialValues}
                validateOnChange
                validate={values => {
                    const errors = {}

                    if (!values.label) {
                        errors.label = 'Campo Obbligatorio'
                    }
                    if (values.type === 'Seleziona Movimento') {
                        errors.type = 'Campo Obbligatorio'
                    }
                    if (boundDevices.length < 1) {
                        errors.boundDevices = 'Campo Obbligatorio'
                    }
                    return errors
                }}

                onSubmit={({ label, type }) => {
                    handleSubmit(label, type)   
                }}
            >
                {props => {
                return (
                <Form className={styles['form-wrapper']}>
                    <div className={styles['field-container']}>
                        <Field
                            type="text"
                            name="label"
                            className={styles['area-name-input']}
                            placeholder="Inserisci Nome Area"
                            />
                        <ErrorMessage className="error" name="label" component="div" />
                    </div>

                    <div className={styles['field-container']}>
                        <Field
                        as="select"
                        name="type">
                            {movementTypes.map(m => {
                                return(
                                    <option
                                    key={m.value}
                                    value={m.value}
                                    >
                                        {m.name}
                                    </option>
                                )
                            })}
                        </Field>
                        <ErrorMessage className="error" name="type" component="div" />
                    </div>

                    <div className={styles['field-container']}>
                        <div className={styles['device-select-container']}>
                            <label htmlFor="type" className={styles['labels']}>ASSOCIA:</label>
                            <div className={styles['devices-container']}>
                                <div className={styles['device-checkbox']}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="boundDevices"
                                            checked={boundDevices.length === devicesIds.length}
                                            value={boundDevices}
                                            onChange={e => {
                                                if (e.target.checked) {
                                                    setBoundDevices(devicesIds);
                                                }

                                                if (e.target.checked === false) {
                                                    setBoundDevices([])
                                                }
                                            }}
                                            />
                                        Seleziona Tutti
                                    </label>
                                </div>
                                {devices.map(device => {
                                    const d = device.deviceId
                                    return (
                                        <div className={styles['device-checkbox']}key={d}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="boundDevices"
                                                    checked={boundDevices.includes(d)}
                                                    value={d}
                                                    onChange={(e) => {
                                                        if (e.target.checked === true) {
                                                            setBoundDevices([...boundDevices, d]);
                                                        }

                                                        if (e.target.checked === false) {
                                                            setBoundDevices(boundDevices.filter(device => device !== d))
                                                        }
                                                    }}
                                                    />
                                                {d}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <ErrorMessage className="error" name="boundDevices" component="div" />

                    </div>
                    <div className={styles['btn-container']}>
                        <NTMButton primary type="submit">CONFERMA</NTMButton>
                        <NTMButton onClick={e => {
                            e.preventDefault();
                            onRemove();
                            props.handleReset()
                            cleanUpForm()
                        }}>ELIMINA</NTMButton>
                    </div>
                </Form>
                )}
                }
            </Formik>

        </div>
    )
}

export default Toolbar;
